import React, { useState } from 'react';
import Breadcrumb from '../../../common/breadcrumb';
import LoadingIndicator from '../../../common/loadingIndicator';
import ClientDashboardFilters from './clientReportDashboardFilters';
import ClientDashboardBody from './clientReportDashboardBody';
import { useAuthenticate } from '../../../../hooks/auth';

const CLIENT_GROUP_ID = 5;

/**
 * ClientDashboard Report
 * @returns {JSX.Element}
 * @constructor
 */
const ClientReportDashboard = () => {
    const { user } = useAuthenticate();
    const isClient = user?.group_id === CLIENT_GROUP_ID;
    const [dashboardData, setDashboardData] = useState(null);
    const [reportFilters, setReportFilters] = useState({
        isLoading: false,
        isSubmitted: false,
    });

    const reportFilterProps = {
        setReportFilters,
        setDashboardData,
        isClient,
        user
    };

    const reportBodyProps = {
        dashboardData,
        reportFilters
    };

    const breadcrumbTitle = isClient ? 'Dashboard' : 'Client Dashboard';
    // clients will not see breadcrumbs on the home landing page
    const breadcrumbParent = isClient ? '' : 'Reports';

    return (
        <>
            <Breadcrumb title={breadcrumbTitle} parent={breadcrumbParent}/>
            <LoadingIndicator isLoading={reportFilters.isLoading}/>
            <ClientDashboardFilters {...reportFilterProps} />
            <ClientDashboardBody {...reportBodyProps} />
        </>
    );
}

export default ClientReportDashboard;
